import Service from "../../Services";

const VenueHireDetails = {
  namespaced: true,
  state: {
    form: {
      id: "",
      venue_hire_id: "",
      floor_id: "",
      name_th: "",
      name_en: "",
      description_en: "",
      description_th: "",
      slug_url: "",
      is_publish: true,
      slide_images: []
    }
  },
  mutations: {
    GET_FORM: (state, res) => {
      state.form = res;
    },
    CLEAR_FORM_DATA: state => {
      state.form = {
        id: "",
        venue_hire_id: "",
        floor_id: "",
        name_th: "",
        name_en: "",
        description_en: "",
        description_th: "",
        slug_url: "",
        is_publish: true,
        slide_images: []
      };
    },
    SET_SLIDE_IMAGE: (state, data) => {
      state.form.slide_images = [
        ...state.form.slide_images,
        {
          ...data
        }
      ];
    },
    REMOVE_SLIDE_IMAGE: (state, index) => {
      state.form.slide_images = state.form.slide_images.filter(
        (detail, itemIndex) => index !== itemIndex
      );
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    getVenueHireDetails({ commit }, page) {
      return Service.VenueHireDetailsAPI.getVenueHireDetails(page);
    },
    // eslint-disable-next-line no-unused-vars
    showVenueHireDetails({ commit }, id) {
      return Service.VenueHireDetailsAPI.showVenueHireDetails(id);
    },
    // eslint-disable-next-line no-unused-vars
    saveVenueHireDetails({ commit }, { id, data }) {
      if (id) {
        return Service.VenueHireDetailsAPI.updateVenueHireDetails(id, data);
      } else {
        return Service.VenueHireDetailsAPI.createVenueHireDetails(data);
      }
    },
    // eslint-disable-next-line no-unused-vars
    deleteVenueHireDetails({ commit }, id) {
      return Service.VenueHireDetailsAPI.deleteVenueHireDetails(id);
    },
    setFormVenueHireDetails({ commit }, res) {
      commit("GET_FORM", res);
    },
    clearFormData({ commit }) {
      commit("CLEAR_FORM_DATA");
    },
    addImage({commit},data){
      commit('SET_SLIDE_IMAGE',data);
    },
    removeImage({commit},index){
      commit('REMOVE_SLIDE_IMAGE',index);
    }
  }
};
export default VenueHireDetails;
